// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/services/google-tag-manager.tsx"
);
import.meta.hot.lastModified = "1717182690463.39";
}
// REMIX HMR END

import TagManager from "react-gtm-module";

export const tagManagerInit = ({ gtmId }: { gtmId?: string }) =>
  gtmId
    ? TagManager.initialize({
        gtmId,
      })
    : null;
